export function formatCurrency(value: number | string, currency: 'EUR' | 'USD' | 'PLN' | 'UAH'): string {
  const currencies = {
    EUR: '€',
    USD: '$',
    PLN: 'zł',
    UAH: '₴',
  };

  // Если значение 0 или валюта не указана, возвращаем '0'
  if (value === 0 || value === '0' || !currency) {
    return '0';
  }

  // Преобразуем value в строку для единообразной обработки
  const strValue = typeof value === 'number' ? value.toString() : value;

  // Проверяем, является ли строка числом
  const numericValue = parseFloat(strValue);
  if (isNaN(numericValue)) {
    return `${currencies[currency]} 0.00`;
  }

  // Для чисел меньше 1, находим первую ненулевую цифру
  if (Math.abs(numericValue) < 1 && numericValue !== 0) {
    // Преобразуем число в строку без экспоненциальной нотации с высокой точностью
    const fixedStrValue = numericValue.toFixed(20).replace(/\.?0+$/, '');
    // Ищем первую ненулевую цифру после запятой
    const match = fixedStrValue.match(/0\.0*([1-9])/);
    if (match) {
      const firstNonZeroIndex = match.index! + match[0].length - 1;
      // Обрезаем до первой ненулевой цифры + 1 знак
      const precision = firstNonZeroIndex + 1;
      return `${currencies[currency]} ${numericValue.toFixed(precision)}`;
    }
  }

  // Для всех остальных чисел форматируем с двумя знаками после запятой
  return `${currencies[currency]} ${numericValue.toFixed(2)}`;
}
export const formatCurrencyString = (price:string) => {
  
  return {
    hour: price?.replaceAll(",", ".")
    .replaceAll('€','')
    .replaceAll(' ','')
    .replaceAll('$','')
    .replaceAll('zł','')
    .replaceAll('₴','')
    .replaceAll('EUR','')
    .replaceAll('USD','')
    .replaceAll('PLN','')
    .replaceAll('UAH',''),
    month: price?.replaceAll(",", ".")
    .replaceAll('€','')
    .replaceAll(' ','')
    .replaceAll('$','')
    .replaceAll('zł','')
    .replaceAll('₴','')
    .replaceAll('EUR','')
    .replaceAll('USD','')
    .replaceAll('PLN','')
    .replaceAll('UAH',''),
  }
}